
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {JiraConfig, ProjectServiceDocument} from "@/interfaces/service.interfaces";
import {addProjectService, getProjectService, updateProjectService} from "@/axios/axios.service";
import {decodeService, encodeService} from "@/shared/local.storage.utils";

@Component({})
export default class SAccProjectJira extends Vue {
  // Les props
  @Prop({default: null}) private prjid!: string | null
  @Prop({default: null}) private srvid!: string | null
  @Prop() public height!: number

  // Les propriétés
  public isValid: boolean = false
  public ruleRequired = (v: string) => v.length > 0 || 'Field required'
  public canModify: boolean = false
  private readonly emptyConfig: JiraConfig = {
    jira_url: '',
    jira_project: '',
    username: '',
    password: '',
    ticket: '',
    parent_ticket: null
  }
  private config: JiraConfig = {...this.emptyConfig}
  private docConfig: ProjectServiceDocument | null = null
  public loading: boolean = false
  public show: boolean = false

  // Les propriétés calculées
  // Les hooks
  public mounted() {
    this.loadConfig()
  }

  // Les méthodes surveillées
  @Watch('prjid')
  public onChangePrjId() {
    this.loadConfig()
  }

  @Watch('srvid')
  public onChangeSrvId() {
    this.loadConfig()
  }

  // Les méthodes d'instance
  private async loadConfig() {
    if (this.prjid && this.srvid) {
      this.loading = true
      // Fetch de la config sauvegardée
      this.docConfig = await getProjectService(this.prjid, this.srvid)
      // Mise a jour de this.config
      this.updateFields()
      this.loading = false
    }
  }

  public async onSave() {
    this.loading = true
    const token = encodeService(this.config)
    // Sauvegarde des données actualisées
    if (this.docConfig && token) {
      // Update
      await updateProjectService(this.docConfig._id, {token})
    } else if (this.prjid && this.srvid && token) {
      // Création
      await addProjectService({
        service: this.srvid,
        prjid: this.prjid,
        active: true,
        token
      })
    }
    await this.loadConfig()
    this.canModify = false
  }

  public onCancel() {
    // Restauration des données initiales
    this.updateFields()

    this.canModify = false
  }

  private updateFields() {
    // Actualisation des champs avec les données issues de la BDD
    if (this.docConfig) {
      this.config = decodeService(this.docConfig.token) as JiraConfig
    } else {
      this.config = {...this.emptyConfig}
    }
  }

  // Les méthodes statiques
}
